// extracted by css-extract-rspack-plugin
export default {"refresh":"RefreshButton-module__refresh__wKFrXUb"};